import { zafClient } from './zafClient'

export async function openModal(parentTicketId?: number | null) {
  if (!zafClient) return;

  const id = parentTicketId || localStorage.getItem('CURRENT_TICKET_ID');


  const data = await zafClient.invoke('instances.create', {
    location: 'modal',
    url: `${window.location.origin}/modal?parent_ticket_id=${id}&t=${Date.now()}`,
    size: {
      width: '1100px',
      height: '600px',
    },
  }) as Record<string, Array<{ instanceGuid: string }>>

  const modalGuid = data['instances.create'][0].instanceGuid
  const modalClient = zafClient.instance(modalGuid)

  modalClient.on('modal.closed', () => {
    console.log('Modal fechado')
  })
}

export async function openEditModal() {
  if (!zafClient) {
    console.warn('ZAF client not available — running outside Zendesk')
    return
  }

  const data = await zafClient.invoke('instances.create', {
    location: 'modal',
    url: `${window.location.origin}/editar-campos`,
    size: {
      width: '1100px',
      height: '600px',
    },
  }) as Record<string, Array<{ instanceGuid: string }>>

  const modalGuid = data['instances.create'][0].instanceGuid
  const modalClient = zafClient.instance(modalGuid)

  modalClient.on('modal.closed', () => {
    console.log('Modal editar campos fechado')
  })
}
